import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TreatmentRevisionDetail, TreatmentRevisionEditModel } from '../model/treatment-revision.model';

const baseUrl = '/api/treatment-revisions';
const baseManualRevisionUrl = '/api/treatments';

@Injectable({ providedIn: 'root' })
export class TreatmentRevisionClient {
    private readonly _httpClient = inject(HttpClient);

    putRevisionReasonTranslation(revisionId: string, translation: string) {
        const divEl = document.createElement('div');
        divEl.innerHTML = translation;
        const translationRaw = divEl.innerText;
        const formData = new FormData();
        formData.append('translation', translation);
        formData.append('translationRaw', translationRaw);
        return this._httpClient.put(`${baseUrl}/${revisionId}/translation`, formData);
    }

    listInactiveRevisions(treatmentId: string) {
        const formData = new FormData();
        formData.append('treatmentId', treatmentId);
        return this._httpClient.post<TreatmentRevisionDetail[]>(`${baseUrl}:listInactive`, formData);
    }

    saveManualRevision(model: TreatmentRevisionEditModel) {
        const { treatmentId, requirement } = model;
        const el = document.createElement('div');
        el.innerHTML = requirement ?? '';
        const requirementRaw = el.innerText;

        return this._httpClient.post(`${baseManualRevisionUrl}/${treatmentId}/manual-revisions`, {
            ...model,
            requirementRaw,
        });
    }

    getDetail(revisionId: string) {
        return this._httpClient.get<TreatmentRevisionDetail>(`${baseUrl}/${revisionId}/detail`);
    }
}
